// Import stores
import AdminStore from './AdminStore';
import BlackoutStore from './BlackoutStore';
import CourseStore from './CourseStore';
import EnrollmentStore from './EnrollmentStore';
import ExamStore from './ExamStore';
import FundingRuleStore from './FundingRuleStore';
import HelpStore from './HelpStore';
import LocationStore from './LocationStore';
import ManagerStore from './ManagerStore';
import MessageStore from './MessageStore';
import PaymentStore from './PaymentStore';
import ProctorStore from './ProctorStore';
import RegisterStore from './RegisterStore';
import ReportStore from './ReportStore';
import ScheduleStore from './ScheduleStore';
import SessionStore from './SessionStore';
import SettingsStore from './SettingsStore';
import SmarterIDStore from './SmarterIDStore';
import StepInStore from './StepInStore';
import StudentStore from './StudentStore';
import SyncStore from './SyncStore';
import TicketStore from './TicketStore';
import VoucherStore from './VoucherStore';
import UserStore from './UserStore';

// Combine stores
const store = {
  AdminStore,
  BlackoutStore,
  CourseStore,
  EnrollmentStore,
  ExamStore,
  FundingRuleStore,
  HelpStore,
  LocationStore,
  ManagerStore,
  MessageStore,
  PaymentStore,
  ProctorStore,
  RegisterStore,
  ReportStore,
  ScheduleStore,
  SessionStore,
  SettingsStore,
  SmarterIDStore,
  StepInStore,
  StudentStore,
  SyncStore,
  TicketStore,
  VoucherStore,
  UserStore
};

export default store;



// WEBPACK FOOTER //
// ./src/app/stores/index.js